import React from 'react';
import { Modal, ModalBody, ModalHeader, RadioGroup, Flex } from '@spothero/ui';
import BorderedRadio from 'common/bordered-radio';
const AirportSortModal = ({ isOpen, onClose, onChange, currentSort, sortOptions, }) => {
    return (<Modal isOpen={isOpen} hasHeader isMobile onClose={onClose}>
            <ModalHeader>Sort by:</ModalHeader>
            <ModalBody display="inline">
                <RadioGroup value={currentSort} onChange={onChange}>
                    <Flex width="100%" flexDirection="column" gap={2}>
                        {sortOptions.map((option, index) => (<BorderedRadio key={index} value={option.value} isSelected={currentSort === option.value}>
                                {option.display}
                            </BorderedRadio>))}
                    </Flex>
                </RadioGroup>
            </ModalBody>
        </Modal>);
};
export default AirportSortModal;
